module.exports = __webpack_public_path__ + "static/media/img_33.04c525c6.JPG";